import "../Style/Saasstack.css";

import androidImg from "../assets/android.png";
import dartImg from "../assets/dart.png";
import firebaseImg from "../assets/firebase.png";
import flutterImg from "../assets/flutter.png";
import githubImg from "../assets/github.png";
import kotlinImg from "../assets/kotlin.png";
import vscodeImg from "../assets/vscode.png";
import postmanImg from "../assets/postman.png";

/* VALUE BOX ICONS */
import commitmentImg from "../assets/commitment.png";
import excellenceImg from "../assets/excellence.png";
import passionImg from "../assets/passion.png";
import priorityImg from "../assets/priority.png";

const tools = [
  { src: kotlinImg, alt: "Kotlin" },
  { src: vscodeImg, alt: "VS Code" },
  { src: postmanImg, alt: "Postman" },
  { src: androidImg, alt: "Android" },
  { src: githubImg, alt: "GitHub" },
  { src: firebaseImg, alt: "Firebase" },
  { src: flutterImg, alt: "Flutter" },
  { src: dartImg, alt: "Dart" },
];

export default function SaasStack() {
  const items = [...tools, ...tools];

  return (
    <section className="saas-stack-section">
      <div className="saas-stack-pattern" aria-hidden="true" />

      <div className="saas-stack-inner">
        <div className="saas-stack-badge">
          <div className="saas-stack-badge-ring" aria-hidden="true" />
          <h2 className="saas-stack-badge-title">Technology Stack</h2>
          <span className="saas-stack-badge-subtitle">
            SaaS Development Tools
          </span>
        </div>

        <div className="saas-stack-right">
          <span className="saas-stack-eyebrow">Tools &amp; Technology</span>

          <h3 className="saas-stack-info-heading">
            Our SaaS Product Development Tech Stack
          </h3>

          <p className="saas-stack-info-desc">
            At MPeoples, we leverage modern frameworks, cloud infrastructure,
            secure backend technologies, and scalable development tools to
            build high-performance SaaS applications. Our technology stack
            ensures reliability, security, flexibility, and seamless user
            experiences for businesses of every size.
          </p>

          <div className="saas-stack-marquee-card">
            <div className="saas-stack-marquee-outer">
              <div className="saas-stack-marquee-track">
                {items.map((tool, i) => (
                  <div className="saas-stack-cell" key={i}>
                    <div className="saas-stack-icon-wrap">
                      <img
                        src={tool.src}
                        alt={tool.alt}
                        className="saas-stack-icon"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* BLUE VALUE BOX */}
      <div className="saas-value-wrapper">
        <div className="saas-value-box">
          <div className="saas-value-card">
            <img
              src={commitmentImg}
              alt="Commitment"
              className="saas-value-image"
            />
            <h4 className="saas-value-title">Commitment</h4>
            <p className="saas-value-desc">
              We are committed to delivering secure, scalable, and
              future-ready SaaS solutions that support your business growth.
            </p>
          </div>

          <div className="saas-value-card">
            <img
              src={excellenceImg}
              alt="Excellence"
              className="saas-value-image"
            />
            <h4 className="saas-value-title">Excellence</h4>
            <p className="saas-value-desc">
              Our developers follow industry best practices and modern
              development standards to create high-quality SaaS platforms.
            </p>
          </div>

          <div className="saas-value-card">
            <img
              src={passionImg}
              alt="Innovation"
              className="saas-value-image"
            />
            <h4 className="saas-value-title">Innovation</h4>
            <p className="saas-value-desc">
              We utilize the latest cloud technologies and automation tools
              to build intelligent, performance-driven SaaS products.
            </p>
          </div>

          <div className="saas-value-card">
            <img
              src={priorityImg}
              alt="Customer Success"
              className="saas-value-image"
            />
            <h4 className="saas-value-title">Customer Success</h4>
            <p className="saas-value-desc">
              Your business success is our priority. We provide ongoing
              support, optimization, and long-term SaaS product maintenance.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}